// import { ParamsFetchType, MethodType, GenerateUrlApiType, ResponseType } from 'src_common/browser/apiUtils';
// import { GenerateUrlApiParamsType } from 'src_common/server/webDriver/sdkApiWebUtils';
import { decodeNumber, decodeString } from 'src/api/utils/commonModelValidators';
import { buildApiItemDefault, buildModelValidator } from 'src/api/utils/modelUtils';
import { buildValidator } from 'src_common/common/mobx-utils/buildValidator';
import * as t from 'io-ts';
import { LanguagesState } from 'src/domains/layouts/state/languagesState/LanguagesState';
import { MultibetPostBodyItemType } from 'src/domains/sportsbook/betting/state/multibetState/Types';

const decodeMultibetPriceModel = buildModelValidator('Multibet PriceModel', {
    payout: buildApiItemDefault(decodeNumber, 0),
    price: buildApiItemDefault(decodeNumber, 0),
    stake: buildApiItemDefault(decodeNumber, 0),
    priceFractional: buildApiItemDefault(decodeString, ''),
});

const decodeMultibetPriceErrorModel = buildModelValidator('Multibet PriceModel Error', {
    code: buildApiItemDefault(decodeString, ''),
    errors: buildApiItemDefault(
        buildValidator(
            'errors',
            t.array(
                t.partial({
                    arguments: t.record(t.string, t.unknown),
                    code: t.string,
                    message: t.string,
                })
            )
        ),
        []
    ),
    message: buildApiItemDefault(decodeString, ''),
});

export type MultibetPriceModelType = ReturnType<typeof decodeMultibetPriceModel>;
export type MultibetPriceModelErrorType = ReturnType<typeof decodeMultibetPriceErrorModel>;

export type MultibetPriceSuccessType = {
    type: 'ok';
    data: MultibetPriceModelType;
};

export type MultibetPriceErrorType = {
    type: 'error';
    data: MultibetPriceModelErrorType;
};

export type MultibetPriceSuspendedType = {
    type: 'suspended';
    data: MultibetPriceModelErrorType;
};

export type MultibetPriceExpiredType = {
    type: 'expired';
    data: MultibetPriceModelErrorType;
};

const errorMessages: Record<string, (language: LanguagesState) => string> = {
    ['multibet-service.BETTING_SELECTIONS_CONFLICTING']: (language: LanguagesState) =>
        language.getTranslation(
            'multibet-service.BETTING_SELECTIONS_CONFLICTING',
            'Some or all of your selections are not currently available.'
        ),
};

export const getMultibetErrorMessage = (
    language: LanguagesState,
    data: MultibetPriceModelErrorType
): string | undefined => {
    const error = data.errors[0];
    if (error !== undefined && error.code !== undefined) {
        const getMessage = errorMessages[error.code];
        if (getMessage !== undefined) {
            return getMessage(language);
        }
    }
    return undefined;
};

// const decode = (
//     status: number,
//     data: ResponseType
// ): MultibetPriceSuccessType | MultibetPriceErrorType | MultibetPriceSuspendedType => {
//     if (status === 200 && data.type === 'json') {
//         const result = decodeMultibetPriceModel(data.json);
//         return {
//             type: 'ok',
//             data: result,
//         };
//     }
//
//     if (status === 400 && data.type === 'json') {
//         const result = decodeMultibetPriceErrorModel(data.json);
//         const { languagesState } = $appState.appLayoutsState;
//
//         if (getMultibetErrorMessage(languagesState, result) !== undefined) {
//             return {
//                 type: 'error',
//                 data: result,
//             };
//         }
//
//         if (result.errors[0]?.message !== 'Bet not possible') {
//             return {
//                 type: 'suspended',
//                 data: result,
//             };
//         }
//
//         return {
//             type: 'error',
//             data: result,
//         };
//     }
//
//     throw new Error(`unhandled response ${status} - ${data.type}`);
// };

export interface ParamsType {
    fixtureId: string;
    stake: number;
    selectionLegs: Array<MultibetPostBodyItemType>;
}

// interface ExpressParamsType {
//     fixtureId: string;
//     stake: number;
//     selectionLegs: Array<MultibetPostBodyItemType>;
// }

// export const multibetGetPrice = {
//     browser: {
//         params: (params: ParamsType): ParamsFetchType<ExpressParamsType> => {
//             const { fixtureId, stake, selectionLegs } = params;
//
//             return {
//                 type: MethodType.POST,
//                 url: '/api-web/get-multibet-price',
//                 body: {
//                     fixtureId,
//                     stake,
//                     selectionLegs,
//                 },
//             };
//         },
//         decode,
//     },
//     express: {
//         method: MethodType.POST,
//         urlBrowser: '/api-web/get-multibet-price',
//     },
//     generateUrlApi: async (params: GenerateUrlApiParamsType<ExpressParamsType>): Promise<GenerateUrlApiType> => {
//         // Mock response for multibet pricing
//         const mockResponse: MultibetPriceModelType = {
//             payout: params.req.body.stake * 2.5,
//             price: 2.5,
//             stake: params.req.body.stake,
//             priceFractional: '3/2',
//         };
//
//         return {
//             passToBackend: false,
//             status: 200,
//             responseBody: mockResponse,
//         };
//     },
// };
